import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { Icon } from '@components/icons';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';

interface IProps {
    title: string;
    type: 'success' | 'error' | 'warning' | 'info';
}

const cx = classNames.bind(styles);

const CustomToast: React.FC<IProps> = ({ title, type }) => {
    const getIcon = () => {
        switch (type) {
            case 'success':
                return <Icon name="filled_check" />;
            case 'error':
                return <Icon name="filled_warning" />;
            case 'warning':
                return <Icon name="filled_warning" />;
            case 'info':
                return <Icon name="info" />;
        }
    };

    return (
        <div className={cx(styles.wrapper, type)}>
            <div className={styles.icon_wrapper}>{getIcon()}</div>
            <div className={styles.title_wrapper}>
                <Typography className={styles.title}>{title}</Typography>
            </div>
        </div>
    );
};

export const showToast = {
    success: (title: string, options?: ToastOptions) => {
        toast(<CustomToast title={title} type="success" />, {
            ...options,
            type: 'success',
            toastId: title,
            style: {}
        });
    },
    error: (title: string, options?: ToastOptions) => {
        toast(<CustomToast title={title} type="error" />, {
            ...options,
            type: 'error',
            toastId: title,
            style: {}
        });
    },
    warning: (title: string, options?: ToastOptions) => {
        toast(<CustomToast title={title} type="warning" />, {
            ...options,
            type: 'warning',
            toastId: title,
            style: {}
        });
    },
    info: (title: string, options?: ToastOptions) => {
        toast(<CustomToast title={title} type="info" />, {
            ...options,
            type: 'info',
            toastId: title,
            style: {}
        });
    }
};

export default CustomToast;
